import { LoginResponse } from '@login/types/LoginTypes';
import { axiosGet, axiosPost } from '@axiosConfig/axiosInstance';

export const doLogin = async (
  userEmail: string,
  userPwd: string,
): Promise<LoginResponse> => {
  const url = '/open/login/user';
  return await axiosGet(url, { userEmail, userPwd });
};

export const doGuestLogin = async (): Promise<LoginResponse> => {
  const url = '/open/login/guest';
  return await axiosPost(url);
};

export const doOAuthLogin = async (
  userEmail: string | null,
  userName: string | null,
  profileImg: string | null,
  uid: string | null,
  loginType: string | null,
): Promise<LoginResponse> => {
  const url = '/open/login/oauth';
  return await axiosPost(url, {
    userEmail,
    userName,
    profileImg,
    uid,
    loginType,
  });
};
